import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useContractorStore } from '../../contexts/contractorStore';
import { Loader2 } from 'lucide-react';

export function ContractorPrivateRoute() {
  const location = useLocation();
  const { isAuthenticated, isTokenExpired, accessToken, _hasHydrated, expiresAt, account } = useContractorStore();

  // Debug logging
  console.log('[ContractorPrivateRoute] Auth state:', {
    _hasHydrated,
    isAuthenticated,
    hasAccessToken: !!accessToken,
    expiresAt,
    isExpired: isTokenExpired(),
    needsPasswordSetup: account?.needsPasswordSetup,
    currentPath: location.pathname,
  });

  // Wait for Zustand to rehydrate from localStorage before making auth decisions
  // This prevents false redirects on initial page load
  if (!_hasHydrated) {
    return (
      <div className="flex items-center justify-center min-h-[200px]">
        <Loader2 className="w-8 h-8 animate-spin text-blue-500" />
      </div>
    );
  }

  // Not authenticated at all - redirect without "session expired" message
  if (!isAuthenticated || !accessToken) {
    return (
      <Navigate
        to="/contractor"
        state={{ from: location }}
        replace
      />
    );
  }

  // Was authenticated but token expired - show session expired message
  if (isTokenExpired()) {
    return (
      <Navigate
        to="/contractor?reason=session-expired"
        state={{ from: location }}
        replace
      />
    );
  }

  // SECURITY: Enforce password setup before allowing access to other protected routes
  // Users who haven't set their password can ONLY access /contractor/set-password
  if (account?.needsPasswordSetup && location.pathname !== '/contractor/set-password') {
    console.log('[ContractorPrivateRoute] Redirecting to password setup - user has not set password');
    return (
      <Navigate
        to="/contractor/set-password"
        replace
      />
    );
  }

  return <Outlet />;
}

export default ContractorPrivateRoute;
